<div class="content">
  <div class="my-show-table">
    <div class="finger-head">
      <mat-form-field class="table-search">
        <mat-label>Search by Name or Email</mat-label>
        <input matInput placeholder="Search by Name or Email" #search [(ngModel)]="search_customer"
          (keydown.enter)="getCustomer()">
      </mat-form-field>
       <button mat-raised-button [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}" class="add-btn" (click)="getCustomer()"><span style="line-height: 24px;margin-right: 5px;display: inline-block;">Submit</span></button>
      <button mat-raised-button [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}" class="add-btn" (click)="setToCronJob()"><span style="line-height: 24px;margin-right: 5px;display: inline-block;">Start Cron Job</span> <mat-icon>alarm</mat-icon></button>
    </div>
    <div class="mat-elevation-z8 ex">
      <div class="billing-table">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>

          <ng-container matColumnDef="first_name">
            <th mat-header-cell *matHeaderCellDef width="10%" mat-sort-header> First Name </th>
            <td mat-cell *matCellDef="let element"> {{element.first_name}} </td>
          </ng-container>

          <ng-container matColumnDef="last_name">
            <th mat-header-cell *matHeaderCellDef width="10%" mat-sort-header> Last Name </th>
            <td mat-cell *matCellDef="let element"> {{element.last_name}} </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
          </ng-container>

          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef> Address </th>
            <td mat-cell *matCellDef="let element"> {{ element.address_1 + ', ' + element.address_2 + ', ' +
              element.city
              + ', ' + element.state + ' ' + element.zip_code }} </td>
          </ng-container>
          <ng-container matColumnDef="subscription_plan">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Subscription Plan</th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.last_transaction; else noPayments">
                {{ getPlanName(element.last_transaction.subscription_plan) }}
              </ng-container>
              <ng-template #noPayments>--</ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="last_transaction">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Transaction</th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.last_transaction; else noPayments">
                {{ getFormattedDate(element.last_transaction.transaction_date) }}
              </ng-container>
              <ng-template #noPayments>--</ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="payment_methods">
            <th mat-header-cell *matHeaderCellDef> Payment Methods </th>
            <td mat-cell *matCellDef="let element"> {{ element.payment_methods.length || '--' }} </td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef> Action </th>
            <td mat-cell *matCellDef="let element" class="show-sm action-col" [class]="{'hidden-row': element.hidden}">
              <div class="table-select">
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Show Actions"
                  [disabled]="element.processing">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="editPaymentMethod(element)">
                    <mat-icon>edit</mat-icon>
                    <span>Edit</span>
                  </button>
                  <button mat-menu-item (click)="getAdmin(element)">
                    <mat-icon>admin_panel_settings</mat-icon>
                    <span>Admin Tool</span>
                  </button>
                  <button mat-menu-item (click)="getUserTransaction(element)">
                    <mat-icon>swap_horiz</mat-icon>
                    <span>Transaction</span>
                  </button>
                </mat-menu>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td colspan="8" class="mat-cell">{{ loading ? 'Loading...':'No records found.'}}</td>
          </tr>
        </table>
      </div>
      <mat-paginator [class]="total_reports > 50 ? '':'hidden_dropdown'" [pageSizeOptions]="[50, 100, 250, 500]"
        aria-label="Select page of the records."></mat-paginator>
    </div>
  </div>
</div>